import { quickList } from "../data";

export default function QuickReference() {
  return (
    <section className="border-t border-background-200/70 bg-background-100 py-14 md:py-20">
      <div className="wrap grid items-start gap-10 lg:grid-cols-[0.8fr_1.2fr]">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <span className="font-poster">06</span>
            <span className="h-3 w-px bg-current opacity-40" />
            <span>速查索引</span>
          </div>
          <h2 className="eyebrow mt-4 text-2xl font-black text-foreground-950 md:text-3xl">
            吃瓜现场的常用词
          </h2>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
            想真正接住「吃瓜91」，最好也认识它身边的几个老熟词。这份索引帮你把围观现场的基本词都过一遍。
          </p>
          <div className="mt-6 inline-flex items-center gap-2 rounded-md bg-accent-100 px-3 py-2 text-xs font-medium text-accent-800">
            <i className="ri-book-3-line h-4 w-4 flex items-center justify-center" />
            词汇基于中文网络语境整理
          </div>
        </div>

        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {quickList.map((it, idx) => (
            <div
              key={it.title}
              className={`flex items-center gap-4 px-5 py-3.5 ${idx !== quickList.length - 1 ? "border-b border-background-200" : ""}`}
            >
              <span className="w-8 shrink-0 font-poster text-lg text-primary-500/70">
                {String(idx + 1).padStart(2, "0")}
              </span>
              <span className="w-24 shrink-0 whitespace-nowrap font-poster text-base text-foreground-900">
                {it.title}
              </span>
              <span className="hidden h-4 w-px bg-background-300 sm:block" />
              <span className="text-sm leading-relaxed text-foreground-600">{it.brief}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}